import { ImageColor } from 'app/core/enums/image-color.enum';
import moment from 'moment';
import { Message } from './message';

export class Channel {
  channelId: string;

  doctorEmail: string;

  doctorName: string;

  productId: string;

  productName: string;

  imageColor: string;

  imageUrl: string;

  imageText: string;

  lastMessage: Message;

  closed: boolean;

  doctorCredential: string;

  closedDate: string;

  numberOfUnread = 0;

  active: string; // TODO user online status

  unsentMessages: Message[] = [];

  constructor(channel: any) {
    this.channelId = channel.channelId;
    this.doctorEmail = channel.doctorEmail;
    this.doctorName = channel.doctorName;
    this.productId = channel.productId;
    this.productName = channel.productName;
    this.imageColor = ImageColor[Math.floor(Math.random() * (Object.keys(ImageColor).length / 2 - 1)) + 0];
    if (this.doctorName) {
      const temp = this.doctorName.split(' ');
      this.imageText = temp[0].charAt(0);
      if (temp.length > 1) {
        this.imageText = this.imageText + temp[temp.length - 1].charAt(0);
      }
    }
    if (channel.lastMessage) {
      this.lastMessage = new Message(channel.lastMessage);
    }
    this.closed = channel.closed;
    this.doctorCredential = channel.doctorCredential;
    if (channel.closedDate) {
      const utcDate = moment.utc(channel.closedDate);
      this.closedDate = moment(utcDate).local().format('MM/DD/YY h:mm A');
    }
    // this.numberOfUnread = channel.unreadMessagesAmount;
  }
}
